import React from 'react';
import { connect } from 'react-redux';
import ControlService from '../../helper/controlservice';
import { updateData } from "../actions";

const _ = require('lodash');

function mapStateToProps(state) {
    return {
        data: state.formDataReducer,
        filterdata: state.formDataReducer.filterdata,
        editformdata: state.formDataReducer.editformdata,
    };
}
function bindAction(dispatch) {
    return {
        update: async (key, value, storekey) => dispatch(updateData(key, value, storekey)),
    };
}
class GroupExpression extends React.PureComponent {
    constructor() {
        super()

        this.state = {
            data: {},
            value: '#'
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.data && nextProps.data[nextProps.formid] != prevState.data) {
            return {
                data: nextProps.data[nextProps.formid]
            };
        }
        else return null; // Triggers no change in the state
    }
    async componentDidUpdate(prevProps, prevState) {
        const { control, formid } = this.props;
        const { data } = this.state;

        var _value = this.evaluate(control, formid, data);
        var value = data && data[control.key] ? data[control.key] : '';
        if (ControlService().isEmptyorNull(value) && ControlService().isEmptyorNull(_value)) {
            value = 0;
            _value = 0;
        }

        if (value != _value) {
            debugger;
            // var value = this.evaluate(control, formid, this.state.data);
            await this.props.update(control.key, _value == '#' ? 0 : _value, formid)
            this.setState({ value: _value });
        }
    }
    componentDidMount() {
        // const { control, action, formid } = this.props;
        // var data = action == 'write' ? this.props.data[formid] : action == 'filter' ? this.props.filterdata : this.props.editformdata;

        // this.setState({ value: this.evaluate(control, formid, data[control.key]) })
        this.setState({ value: this.state.data ? this.state.data[this.props.control.key] : '#' })
    }

    getArray(expression, data) {
        var arr = [];
        if (Array.isArray(expression.value1)) {
            expression.value1.forEach(item => {
                if (data[item.value])
                    arr.push(data[item.value]);
            });
        } else if (expression && Array.isArray(data[expression.value1])) {
            data[expression.value1].forEach(item => {
                if (!isNaN(parseInt(item[expression.value2])))
                    arr.push(Number.isInteger(item[expression.value2]) ? parseInt(item[expression.value2]) : _.round(item[expression.value2], 2));
            });
        }
        return arr;
    }
    getOpration(data) {

        var operation = null;
        var expression = this.props.control.expression ? this.props.control.expression : {};
        let arr = null;
        switch (expression.type) {
            case "max":
                arr = this.getArray(expression, data);
                operation = _.max(arr);
                break;
            case "mean":
                arr = this.getArray(expression, data);
                operation = _.mean(arr);
                break;
            case "min":
                arr = this.getArray(expression, data);
                operation = _.min(arr);
                break;
            case "sum":
                arr = this.getArray(expression, data);
                operation = _.sum(arr);
                break;
            case "length":
                // var arr = this.getArray(expression);
                operation = data[expression.value1] ? data[expression.value1].length : 0;
                break;
            case "concat":
                arr = this.getArray(expression, data);
                var separator = this.props.control.separator ? this.props.control.separator : ' ';
                operation = Array.isArray(arr) ? _.map(arr).join(separator) : '';
                break;
            case "abs":
                // operation = data[expression.value1] ? Math.abs(data[expression.value1]) : 0;
                break;
            case "ceil":
                operation = data[expression.value1] ? Math.ceil(data[expression.value1]) : 0;
                break;
            case "floor":
                operation = data[expression.value1] ? Math.floor(data[expression.value1]) : 0;
                break;
            case "round":
                operation = data[expression.value1] ? Math.round(data[expression.value1]) : 0;
                break;
            case "pow":
                operation = data[expression.value1] ? Math.pow(data[expression.value1], expression.value2) : 0;
                break;
            case "sqrt":
                operation = data[expression.value1] ? Math.sqrt(data[expression.value1]) : 0;
                break;
            default:
                operation = 0;
                break;

        }
        return operation || operation == 0 || operation == '' || operation == "0" ? operation : 0;
    }
    evaluate(control, formid, data) {
        try {
            // data[this.props.control.key] = this.getOpration(data);
            var val = this.getOpration(data);
            if (typeof val === 'number') {
                //it's a number
                val = Number.isInteger(val) ? val : _.round(val, 2)
            }
            return val;
        }
        catch (e) {
            return "#";
        }
    }
    gethtml(control, data) {
        var s = "<" + control.formattype + ">" + ControlService().numberToCommas(this.state.value) + "</" + control.formattype + ">";
        return s;
    }
    render() {
        const { control } = this.props;

        return (
            control.hidden ?
                null
                :
                <div className="form-group">
                    <label>{control.label}</label>
                    <div dangerouslySetInnerHTML={{ __html: this.gethtml(control) }}></div>
                </div>
        );
    }
}

export default connect(
    mapStateToProps, bindAction
)(GroupExpression);